import React, { Fragment } from 'react'
import "./ProductivityToolsDescriptionContainer.scss"
import translate from '../../../i18n/translate'

const ProductivityToolsDescriptionContainer = (props: any) => {
    const { headingTitle, featureDescription, featureImg } = props;
    return (
        <Fragment>
            <h3 className="tools-heading" data-testid="tools-heading">{translate(headingTitle)}</h3>
            <div className="tools-box" style={{ backgroundImage: `url(${featureImg})`}}>
                <div className="tools-box-description">{translate(featureDescription)}</div>
            </div>
        </Fragment>
    )
}

export default ProductivityToolsDescriptionContainer